import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-asset-deprciation-method-controller',
  templateUrl: './asset-deprciation-method-controller.component.html',
  styleUrls: ['./asset-deprciation-method-controller.component.css']
})
export class AssetDeprciationMethodControllerComponent implements OnInit {

  assetDepreciationDataList:any = [];
  pageNumber: number = 0;
  totalRecords: number = 0;
  first: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;
  isLoading: any = false
  id: any

  addForm: any | FormGroup
  cid:any
  formSubmit: boolean = false;

  updateForm: any | FormGroup
  isEdit: boolean = false
  assetDepreciationData: any = [];

  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }

  searchFilter: any = "";
  recordId: any = "";
  recordName: any = "";

  constructor(
    private generic_service: GenericService,
    private fb: FormBuilder,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {

    let href:any = window.location.href;
    let messages = href.split('/') 
    let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid')
    this.addForm = this.fb.group({
      methodDescription: [],
      methodName: ['',[Validators.required]]
    })
    this.updateForm = this.fb.group({
      methodDescription: [],
      methodName: ['',[Validators.required]]
    })
    this.getAllAssetDepreciationMethod();
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page+1;
  }

  getAllAssetDepreciationMethod(){
    this.isLoading = true
    this.generic_service.getAllAssetDepreciationMethod().subscribe(
      (res:any)=> {
        console.log(res)
        this.assetDepreciationDataList = res.response
        this.totalRecords = res.response.length
        this.isLoading = false
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  getAssetDepreciationMethodById(assetDepreciationMethodId:any){
    this.generic_service.getAssetDepreciationMethodById(assetDepreciationMethodId).subscribe(
      (response:any)=>{
        this.assetDepreciationData = []
        this.assetDepreciationData.push(response.response)
        this.updateForm.patchValue({
          methodDescription: response.response.methodDescription,
          methodName: response.response.methodName
        })
        this.isEdit = true
      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalAdd")?.click()
    document.getElementById("closeModalUpdate")?.click()
    document.getElementById("closeModalDelete")?.click()
  }

  deleteAssetDepreciationMethod(){
    this.generic_service.deleteAssetDepreciationMethod(this.id).subscribe(
      (response:any)=>{
        this.toastr.success(response.message)
        this.getAllAssetDepreciationMethod();
        this.cancelModel();
      },
      (err:any)=>{
        this.toastr.error(err.errors[0].description)
      }
    )
  }

  deleteIdSelect(id:any,list: any){
    this.id = id
    this.recordId = list.assetDepreciationMethodId
    this.recordName = list.methodName
  }
  
  clearData(){
    this.recordId = "";
    this.recordName = "";
  }


  refreshAll(){
    this.pageNumber = 1
    this.first = 0
    this.searchFilter = ""
    this.getAllAssetDepreciationMethod()
  }

  getAllAssetDepreciationMethodByWildSearch(){
    console.log(this.searchFilter)
    if(this.searchFilter == "" || this.searchFilter == null){
      return
    }
    this.generic_service.getAllAssetDepreciationMethodByWildSearch(this.searchFilter).subscribe(
      (res: any) => {
        if(res.response == null || res.response.length == 0 || res.response == undefined){
        this.assetDepreciationDataList = []
        this.totalRecords = 0
          return

        }
        this.assetDepreciationDataList = res.response
        this.totalRecords = res.response.length
      },
      (err: any) => {
        console.log(err);
      }
    );
  }


  addAssetDepreciationMethod(){

    if(this.formSubmit){
      return
    }
    if(!this.addForm.valid){
      this.toastr.error("Please fill in all required fields");
      this.formSubmit = false;
      return
    }

    this.formSubmit = true;


    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "methodName": this.addForm.get('methodName').value,
      "methodDescription": this.addForm.get('methodDescription').value,
      "cid": Number(this.cid),
    }

    console.log(body)
    this.generic_service.addAssetDepreciationMethod(body).subscribe(
      (response:any)=>{
        this.formSubmit = false;
        this.addForm.reset()
        this.cancelModel()
        this.getAllAssetDepreciationMethod();

        this.toastr.success(response.message);
      },
      (err:any)=>{
        console.log(err)
        this.formSubmit = false;
        this.toastr.error(err.error.errors[0].description);
      }
    )
  }

  updateAssetDepreciationMethod(){
    this.formSubmit = true;
    if(!this.updateForm.valid){
      this.toastr.error("Please fill in all required fields");
      return
    }
    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "id": this.assetDepreciationData[0].id,
      "assetDepreciationMethodId": this.assetDepreciationData[0].assetDepreciationMethodId,
      "methodName": this.updateForm.get('methodName').value,
      "methodDescription": this.updateForm.get('methodDescription').value,
      "cid": Number(this.cid),
    }
    console.log(body)
    this.generic_service.updateAssetDepreciationMethod(body).subscribe(
      (response:any)=>{
        this.isEdit = false
        this.getAllAssetDepreciationMethod();
        this.cancelModel()
        this.formSubmit = false;
        this.updateForm.reset()
        this.toastr.success(response.message);
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      },
    )
  }

}